import { type FC, useEffect, useState } from 'react';

import CodeMirrorHTML from '@editor2/components/CodeMirrorHTML';
import { type QuestionPayload, type ResponseBoard } from '@editor2/types/pageElements';
import { updateElement } from '@editor2/reducers/editor/editorSlice';

import { useDebouncedDispatch } from '@editor2/hooks/useDebouncedDispatch';

interface Props {
	element: ResponseBoard;
	courseId: number;
	question: QuestionPayload;
	index: number;
}

const ResponseBoardQuestion: FC<Props> = (props) => {
	const { element, courseId, question, index } = props;

	const commonPayload = { elementId: element.family_id, courseId };

	const debouncedDispatch = useDebouncedDispatch();

	const [questionBody, setQuestionBody] = useState(question.body);

	useEffect(() => {
		if (question.body !== questionBody) {
			setQuestionBody(question.body);
		}
	}, [question]);

	const handleQuestionBodyChange = (value: string) => {
		setQuestionBody(value);
		debouncedDispatch(
			updateElement({
				...commonPayload,
				questions: [
					...element.questions.slice(0, index),
					{ ...question, body: value },
					...element.questions.slice(index + 1)
				]
			})
		);
	};

	return (
		<CodeMirrorHTML
			value={questionBody}
			showTips={false}
			options={{ placeholder: 'Question', lineNumbers: false, gutters: [] }}
			onChange={(value) => handleQuestionBodyChange(value)}
		/>
	);
};

export default ResponseBoardQuestion;
